<ng-container *transloco="let t">
    <section
        fxFlex="100"
        fxFlex.xs="100"
        fxFlex.sm="100"
        fxLayout="column"
        fxLayoutAlign="space-between"
        fxFlexFill
    >
        <h1>{{ header }}</h1>
        <p>
            {{ t("auth.account-verification.securityCodeNotice") }}
        </p>

        <code-input
            [isCodeHidden]="false"
            (codeCompleted)="onCodeCompleted($event)"
        ></code-input>

        <div class="actions">
            <button mat-button (click)="goBack()">
                <mat-icon color="accent">arrow_back</mat-icon>
                {{ t("shared.go-back") | uppercase }}
            </button>
            <button
                mat-raised-button
                color="accent"
                (click)="submitSecurityCode()"
            >
                {{ continueText | uppercase }}
            </button>
        </div>
    </section>
</ng-container>
